function page (path) {
  return () => import(/* webpackChunkName: '' */ `~/pages/${path}`).then(m => m.default || m)
}

export default [
  { path: '/', name: 'configurator', component: page('configurator.vue') },
  { path: '/show/:name/:definition?', component: page('configurator.vue') },
  { path: '/checkout/cart', name: 'checkout.cart', component: page('checkout/cart.vue') },
  { path: '/checkout/customer', name: 'checkout.customer', component: page('checkout/customer.vue') },
  { path: '/checkout/payment', name: 'checkout.payment', component: page('checkout/payment.vue') },
  { path: '/checkout/total', name: 'checkout.total', component: page('checkout/checkoutTotal') },
  { path: '/checkout/success', name: 'checkout.success', component: page('checkout/success.vue') },
  { path: '/paypal/success/:id', name: 'paypal.success', component: page('checkout/payment/paypal/success') },
  { path: '/paypal/cancel', name: 'paypal.cancel', component: page('checkout/payment/paypal/cancel') },
  { path: '/sofort/success/:id', name: 'sofort.success', component: page('checkout/payment/sofort/success') },
  { path: '/sofort/cancel', name: 'sofort.cancel', component: page('checkout/payment/sofort/cancel') },
  { path: '/cat/:name', name: 'category', component: page('category/index') },
  { path: '/product/:product', name: 'product', component: page('category/productDetail') },

  { path: '*', component: page('errors/404.vue') }
]
